import React, { useMemo } from 'react';
import AssignedTaskCard from '../AssignedTaskCard';

export default function TaskHistoryModal({ tasks, onClose }) {
  const list = useMemo(() => {
    if (!tasks) return [];
    return Array.isArray(tasks) ? tasks : Object.values(tasks);
  }, [tasks]);

  return (
    <>
      <div className="modal-backdrop fade show" role="presentation" onClick={onClose} />
      <div className="modal show d-block" tabIndex="-1" role="dialog">
        <div className="modal-dialog modal-dialog-scrollable" role="document">
          <div className="modal-content border-0 shadow">
            <div className="modal-header border-bottom-0 pb-0">
              <h5 className="modal-title fw-semibold">Task history</h5>
              <button
                type="button"
                className="btn-close"
                onClick={onClose}
                aria-label="Close"
              />
            </div>
            <div className="modal-body pt-2">
              {list.length > 0 ? (
                list.map((task) => (
                  <div key={task.id} className="mb-2">
                    <AssignedTaskCard task={task} />
                  </div>
                ))
              ) : (
                <p className="text-muted small mb-0">No completed tasks</p>
              )}
            </div>
            <div className="modal-footer border-top-0 pt-0">
              <button type="button" className="btn btn-sm btn-secondary" onClick={onClose}>
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
